import { Injectable } from '@angular/core';
import { Network, ConnectionStatus } from '@capacitor/network';
import { Events } from './events.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {
  connectionStatus: boolean;

  constructor(private events: Events) {
  }

  async setupSubscriptions() {
    Network.addListener('networkStatusChange', (status: ConnectionStatus) => {
      if (status.connected === false && status.connectionType !== 'none' ) {
        console.log('will soon be connected');
      } else if (status.connected !== this.connectionStatus) {
        this.connectionStatus = status.connected;
        console.log('connection changed, publishing event', this.connectionStatus);
        this.events.publish('connection:change', this.connectionStatus);
      }
      
    });

    // set initial state
    this.connectionStatus = (await Network.getStatus()).connected;
  }

  async getConnectionStatus() {
    const status = await Network.getStatus();
    console.log('Network status:', status);
    this.connectionStatus = status.connected;
    return this.connectionStatus;
  }

}
